<template>
    <transition name="fade">
    <div id="pdf-viewer">
        <div class="tips-action" id="show-pdf-anim">
            Cliquez sur l'écran <br> de l'ordinateur
            <img src="@/assets/svg/hand_up.svg"
                 alt="Symbole en forme de main indiquant l'endroit où l'utilisateur dois intéragir">
        </div>
        <div class="transparent-action" @click="showPdfViewer(true)"></div>
        <div id="pdf">
            <iframe src="https://drive.google.com/file/d/1i4QRUkWKplzHbz96JJHqcy8R5FI1JOfS/preview" width="640" height="480"></iframe>
            <div id="back" @click="showPdfViewer(false)">Retour sur la vidéo</div>
        </div>

    </div>
    </transition>
</template>
<script>
    export default {
        name: 'PdfViewer',
        methods: {
            showPdfViewer(pdfState) {
                if (pdfState === true) {
                    this.$parent.video.pause()
                    $('#pdf').fadeIn()
                    $('#show-pdf-anim').hide()
                } else if (pdfState === false) {
                    this.$parent.video.play()
                    $('#pdf').fadeOut()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #pdf-viewer {
        .tips-action {
            text-align: center;
            font-size: 1.875rem;
            color: #fff;
            font-family: 'Roboto Condensed', sans-serif;
            position: absolute;
            width: 23%;
            height: 28%;
            top: 22%;
            left: 19%;
            img {
                width: 20%;
                display: block;
                margin: 20px auto auto auto;
                animation: hand-animation 700ms ease-in-out infinite alternate;
            }
            @keyframes hand-animation {
                0% {
                    transform: translateY(0px);
                }
                100% {
                    transform: translateY(20px);
                }
            }
        }

        .transparent-action {
            position: absolute;
            width: 28%;
            height: 33%;
            top: 54%;
            left: 16%;
            background-color: transparent;
            transform: rotateZ(-2deg);
            cursor: pointer;
        }

        #pdf {
            display: none;
            iframe {
                position: fixed;
                width: 100%;
                height: 100%;
                z-index: 5;
                left: 0;
                top: 0;
            }
            #back {
                border: 1px solid #2235a1;
                background-color: #2235a1;
                color: #fff;
                padding: 20px 40px;
                border-radius: 50px;
                font-size: 1rem;
                position: fixed;
                transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
                cursor: pointer;
                outline: none;
                overflow: hidden;
                bottom: 10%;
                left: 5%;
                z-index: 6;
            }
        }
    }


</style>